module.exports = __webpack_public_path__ + "img/5.956a23f0.jpeg";